import React, { useEffect } from "react";
import Routes from "./routes";
import { Slide, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { fetchProfile } from "./store/auth/authActions";
import "./assets/scss/themes.scss";
import "./assets/scss/site.scss";
import LightboxModal from "./views/LightboxModal";

const App = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const role = auth?.user_role;

  useEffect(() => {
    if (!auth.isLoaded) {
      dispatch(fetchProfile());
    }
  }, [auth, dispatch]);

  if (!auth.isLoaded) return null;

  return (
    <div className={`app role-${role}`}>
      <Routes role={role} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <LightboxModal />
    </div>
  );
}

export default App;
